import { createContext, useCallback, useContext, useEffect, useState } from "react";
import api, { clearLegacyTokens } from "@/lib/api";
import { clearOfflineCache } from "@/lib/offline-cache";

const AuthContext = createContext(null);

export function AuthProvider({ children }) {
  const [user, setUser] = useState(null); // null = vérification, false = non connecté, objet = connecté
  const [loading, setLoading] = useState(true);

  const refresh = async () => {
    clearLegacyTokens();
    try {
      const { data } = await api.get("/auth/me");
      setUser(data);
    } catch {
      setUser(false);
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    refresh();
    const onStorage = (e) => { if (e.key === "pi_logout") setUser(false); };
    window.addEventListener("storage", onStorage);
    return () => window.removeEventListener("storage", onStorage);
  }, []);

  const logout = useCallback(async (reason) => {
    try {
      await api.post(reason ? `/auth/logout?reason=${reason}` : "/auth/logout");
    } catch {
      /* ignore */
    }
    clearOfflineCache();
    localStorage.setItem("pi_logout", String(Date.now()));
    setUser(false);
  }, []);

  return (
    <AuthContext.Provider value={{ user, setUser, loading, logout, refresh }}>
      {children}
    </AuthContext.Provider>
  );
}

export const useAuth = () => useContext(AuthContext);
